/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react';// eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import reactMixin from 'react-mixin';
import styles from './LoginPage.scss';
import baseComponent from '../../decorators/baseComponent';
import ProgressButton from '../ProgressButton';
import Header from '../Header';
import Context from '../../Context';
import * as LoginActions from '../../actioncreators/LoginActions';
import BaseReactComponent from '../Util/BaseReactComponent';
import {connect} from 'react-redux';
import {TextField} from 'material-ui';
import LinkedStateMixin from 'react-addons-linked-state-mixin';

@connect(state => ({
  inprogress: state.login.inprogress,
  router: state.router
}))
//@withContext
@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin)
class LoginPage extends BaseReactComponent {

  constructor(props) {
    super(props);
    this.state = {
      user: '',
      password: '',
      inprogress: false
    };
  }

  keyup(e) {
    if (e.which === 13) {
      this.login(e);
    }
  }

  setUsername = (event, username) => {
    this.setState({user:username});
  }

  setPassword = (event, password) => {
    this.setState({password:password});
  }

  login(e) {
    if (e) {
      e.preventDefault();
    }

    LoginActions.login(this.state.user, this.state.password, this.props.location.query.nextPathname, this.context.router)(this.props.dispatch);
  }

  render() {
    let title = 'Inloggen';
    Context.getInstance().onSetTitle(title);

      return (
        // <MuiThemeProvider muiTheme={}>
      <div className="LoginPage">
        <Header pageName="loginpage" showMenu={false}/>

        <div className="LoginPage-container">
          <div className="z-depth-2 LoginPage-container-main clearfix">
            <div id="LoginPage-header">
              <div className="LoginPage-dialog">
                <div className="row" id="LoginPage-header-row">
                  <div className="col s12">
                    <h1>{this.getIntlMessage('loginpage.login-title')}</h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="LoginPage-dialog">
              <form role="form" onKeyUp={this.keyup.bind(this)}>
                <TextField
                  id="username" className="inputfield" onChange={this.setUsername} floatingLabelText={this.getIntlMessage('loginpage.username-placeholder')}
                  // hintText={this.getIntlMessage('loginpage.username-placeholder')}
                />
                <TextField
                  id="password" className="inputfield" onChange={this.setPassword} floatingLabelText={this.getIntlMessage('loginpage.password-placeholder')}
                  type="password"
                  // hintText={this.getIntlMessage('loginpage.password-placeholder')}
                />
                <div className="form-group">
                  <a href="forgotPassword" className="LoginPage-password-forgot-link">{this.getIntlMessage('loginpage.forgot-password')}</a>
                </div>
                <div className="row">
                  <div className="input-field col s12" id="LoginPage-submit-col">
                    <ProgressButton inprogress={this.props.inprogress} onClick={this.login.bind(this)}>
                      {this.getMessage('login-button')}
                    </ProgressButton>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      // </MuiThemeProvider>
    );
  }
}

LoginPage.defaultProps = {
  componentName: 'loginpage'
};

const types = BaseReactComponent.contextTypes;

BaseReactComponent.contextTypes = {
  ...types,
  router: React.PropTypes.object.isRequired
};

export default LoginPage;



// WEBPACK FOOTER //
// /src/components/LoginPage/LoginPage.js